// Wasapi white-label: applied as vue-i18n `postTranslation` hook so every
// translated string (all locales, current and future upstream strings) has
// upstream branding replaced by the installation branding.
export const DEFAULT_BRAND_NAME = 'Wasapi';
export const DEFAULT_BRAND_HOST = 'wasapi.com.br';
export const BRAND_TERMS_URL = `https://${DEFAULT_BRAND_HOST}/termos-de-servico`;
export const BRAND_PRIVACY_URL = `https://${DEFAULT_BRAND_HOST}/politica-de-privacidade`;
export const DEFAULT_APP_HOST = 'dash.wasapi.com.br';
export const BRAND_HELP_URL = `https://${DEFAULT_APP_HOST}/hc/guia-do-usuario/pt_BR`;

const UPSTREAM_BRAND_NAME = 'Chatwoot';

export const getBrandName = (installationName = null) => {
  const name =
    installationName ||
    window.globalConfig?.INSTALLATION_NAME ||
    window.globalConfig?.installationName;
  return name && name !== UPSTREAM_BRAND_NAME ? name : DEFAULT_BRAND_NAME;
};

export const rebrandText = (text, installationName = null) => {
  if (typeof text !== 'string' || !/chatwoot/i.test(text)) return text;

  return text
    .replace(
      /https?:\/\/(www\.)?chatwoot\.com\/terms[\w-]*\/?/g,
      BRAND_TERMS_URL
    )
    .replace(
      /https?:\/\/(www\.)?chatwoot\.com\/privacy[\w-]*\/?/g,
      BRAND_PRIVACY_URL
    )
    .replace(/app\.chatwoot\.com/g, DEFAULT_APP_HOST)
    .replace(/(www\.)?chatwoot\.com/g, DEFAULT_BRAND_HOST)
    .replace(/chatwoot\.help/g, window.location.host)
    .replace(/\bChatwoot\b/g, getBrandName(installationName));
};

export const brandingPostTranslation = translated => rebrandText(translated);
